import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import BulkImportsGrid from '../../components/grids/BulkImportsGrid';

class BulkImports extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: 'Přehled hromadných zápisů' }]);
  }

  onRowClick = ({ id }) => {
    this.props.push(`${this.props.auth.startUrl}/hromadne-zapisy/${id}`);
  };

  render() {
    const { auth } = this.props;
    return (
      <BulkImportsGrid
        gridName="bulkImportsGrid"
        url={`${auth.startUrl}/api/hromadne-zapisy`}
        onRowClick={this.onRowClick}
      />
    );
  }
}

export default connect(null, { breadcrumbs, push })(BulkImports);
